// extracted by mini-css-extract-plugin
export default {"textarea":"TextArea_textarea__akhBe","error":"TextArea_error__8NMqz"};